import { render } from "./AdminClaimInvoices.vue?vue&type=template&id=b27dac46"
import script from "./AdminClaimInvoices.vue?vue&type=script&lang=js"
export * from "./AdminClaimInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__